import { createSlice } from '@reduxjs/toolkit';

import RefData from 'modules/refData/types/RefData';
import refDataApi from './service';

const refDataSlice = createSlice({
  name: 'refData',
  initialState: {} as RefData,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(refDataApi.endpoints.getConfig.matchFulfilled, (state, action) => ({
      ...state,
      ...action.payload,
    }));
    builder.addMatcher(refDataApi.endpoints.getWorkflows.matchFulfilled, (state, action) => ({
      ...state,
      workflows: action.payload,
    }));
  },
});

export default refDataSlice;
